import React from 'react';
import styles from '../../styles/overlays/Overlay.module.css';

interface OverlayProps {
  isVisible: boolean;
  isSmallScreen: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  clickToClose?: boolean;
  isExpanded?: boolean;
}

const Overlay: React.FC<OverlayProps> = ({ 
  isVisible, 
  isSmallScreen, 
  onClose, 
  children, 
  clickToClose = true,
  isExpanded = false
}) => {
  // Lock body scroll when overlay is visible (iOS fix)
  React.useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [isVisible]);

  if (!isVisible) return null;

  const handleOverlayClick = () => {
    if (clickToClose && onClose) {
      onClose();
    }
  };

  const handleContentClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div 
      className={`${styles.overlay} ${isSmallScreen ? styles.mobile : styles.desktop} ${isExpanded ? styles.expanded : ''}`}
      onClick={handleOverlayClick}
    >
      <div 
        className={`${styles.content} ${isSmallScreen ? styles.mobileContent : styles.desktopContent} ${isExpanded ? styles.expanded : ''}`}
        onClick={handleContentClick}
      >
        {children}
      </div>
    </div>
  );
};

export default Overlay;